// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_ProductFiscalRemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/product_fiscal/remover
 *
 * Returns null dados on success.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type So_ProductFiscalRemoverResponseDados = null;

export type So_ProductFiscalRemoverResponse = ApiResponse<So_ProductFiscalRemoverResponseDados>;

registerResponseContract('So_ProductFiscalRemoverResponse', {})
